module.exports = __webpack_public_path__ + "img/maps.b8a285c5.png";